var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('dv-decoration-6',{staticStyle:{"width":"90px","height":"30px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }